import { useCallback } from "react";

import { useFormikContext } from "formik";
import { isPresent } from "neetocist";
import useHotkeys from "neetohotkeys";

const useEditor = ({
  onContentChange,
  editorContentFieldName,
  onAttachmentChange,
  onTitleChange,
  titleFieldName,
  editorRef,
  titleRef,
}) => {
  const { setFieldValue, errors } = useFormikContext();

  const handleContentChange = useCallback(
    content => {
      setFieldValue(editorContentFieldName, content);
      onContentChange?.(content);
    },
    [editorContentFieldName, onContentChange, setFieldValue]
  );

  const handleAttachmentChange = useCallback(
    attachments => {
      setFieldValue("attachments", attachments);
      onAttachmentChange?.(attachments);
    },
    [onAttachmentChange, setFieldValue]
  );

  const handleTitleChange = event => {
    const title = event.target.value;
    setFieldValue(titleFieldName, title);
    onTitleChange?.(title);
  };

  const handleEditorBackspaceKeypress = () => {
    const editor = editorRef.current?.editor;
    const selection = editor?.state?.selection;
    if (
      editor?.isFocused &&
      isPresent(titleRef.current) &&
      selection?.anchor === 1
    ) {
      const title = titleRef.current.value;
      titleRef.current.focus();
      titleRef.current.setSelectionRange(title?.length, title?.length);
    }
  };

  const titleHotkeyRef = useHotkeys(
    "return",
    () => {
      editorRef.current?.editor?.commands?.insertContentAt(0, "<p />");
      editorRef.current?.editor?.commands?.focus("start");
    },
    { mode: "scoped" }
  );

  const editorHotkeyRef = useHotkeys(
    "backspace",
    handleEditorBackspaceKeypress,
    { mode: "scoped" }
  );

  return {
    handleContentChange,
    handleAttachmentChange,
    handleTitleChange,
    editorHotkeyRef,
    titleHotkeyRef,
    errors,
  };
};

export default useEditor;
